interface Testimonial {
  quote: string;
  author: string;
  authorTitle?: string;
  avatarUrl?: string;
  rating?: number;
}

interface TestimonialProps {
  testimonials?: Testimonial[];
}

function Stars({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5" aria-label={`${rating} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} className={`w-4 h-4 ${i < rating ? 'text-amber-400' : 'text-zinc-200'}`} fill="currentColor" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function TestimonialBlock({ props }: { props: TestimonialProps }) {
  const items = props.testimonials ?? [];
  if (items.length === 0) return null;

  return (
    <div className="py-8 px-4">
      <div className={`grid grid-cols-1 gap-6 ${items.length > 1 ? 'sm:grid-cols-2 lg:grid-cols-3' : ''}`}>
        {items.map((t, i) => (
          <div key={i} className="bg-white border border-zinc-100 rounded-xl p-6 shadow-sm flex flex-col gap-4">
            {t.rating != null && t.rating > 0 && <Stars rating={t.rating} />}
            <p className="text-zinc-700 text-base italic leading-relaxed">"{t.quote}"</p>
            <div className="flex items-center gap-3 mt-auto">
              {t.avatarUrl ? (
                <img src={t.avatarUrl} alt={t.author} className="w-9 h-9 rounded-full object-cover flex-shrink-0" loading="lazy" />
              ) : (
                <div className="w-9 h-9 rounded-full bg-zinc-200 flex items-center justify-center flex-shrink-0 text-zinc-500 font-semibold text-sm">
                  {t.author.charAt(0).toUpperCase()}
                </div>
              )}
              <div>
                <p className="font-semibold text-zinc-800 text-sm">{t.author}</p>
                {t.authorTitle && <p className="text-xs text-zinc-500">{t.authorTitle}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
